<template>
	<div class="sip-view-page">
        <div class="nk-block-head nk-block-head-sm sip-view-head">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{ trans('general.about') }}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Product context and release details.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row sip-view-grid">
            <div class="col-12 col-lg-8">
                <div class="card sip-view-card">
                    <div class="card-body sip-view-rich" v-html="content"></div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="card sip-view-card">
                    <div class="card-body">
                        <product :product="product"></product>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import product from './product'

	export default {
		components: {product},
		data() {
			return {
				content: '',
				product: {}
			}
		},
		mounted(){
			if(!helper.hasRole('admin')) {
				this.$router.push('/');
			}
            toastr.success(i18n.general.wait_while_loading);
			axios.get('/api/about')
				.then(response => response.data)
				.then(response => {
					this.content = response.about;
					this.product = response.product;
				})
				.catch(error => {
					helper.showDataErrorMsg(error);
				})
		},
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        }
	}
</script>
